export default __webpack_public_path__ + "static/media/backgroundmobile.5aae7186.png";